import {baseAxios} from '../helper/axiosHelper';

export const companygroupService = {
    getCompanyGroups,
    insertCompanyGroup,
    updateCompanyGroup,
    deleteCompanyGroup,
    getPossibleMember,
    updateCompanyGroupMember
};

function getCompanyGroups() {

    return baseAxios.get('companygroup/companygroups')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function getPossibleMember(id) {

    return baseAxios.get('companygroup/companygroupmember/possible',{params: {group_fk: id}})
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function insertCompanyGroup(data) {

    return baseAxios.post('companygroup/companygroup',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function updateCompanyGroup(data) {

    return baseAxios.put('companygroup/companygroup',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function updateCompanyGroupMember(data) {

    return baseAxios.put('companygroup/companygroup/member',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function deleteCompanyGroup(id) {

    return baseAxios.delete('companygroup/companygroup',{params: {id: id}})
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

deleteCompanyGroup